import type { HttpClient } from "../http";
import type { CreateOrderRequest, OrderDTO, OrderStatus } from "../types";

export function ordersResource(http: HttpClient) {
  return {
    list: () => http.get<OrderDTO[]>("/orders"),
    get: (id: number) => http.get<OrderDTO>(`/orders/${id}`),
    create: (body: CreateOrderRequest) => http.post<OrderDTO>("/orders", body),
    transition: (id: number, target: OrderStatus) =>
      http.post<OrderDTO>(`/orders/${id}/transitions`, { target }),
  };
}
